/**
 * @typedef {string} InsuranceType
 */

/**
 * @type {Object.<string, InsuranceType>}
 */
export const InsuranceType = {
    Health: 'health',
    Dental: 'dental',
    Vision: 'vision',
};

/**
 * @typedef {object} PopularInsuranceData
 * @property {string} name
 * @property {int[]} mappableInsuranceIds
 * @property {string} imageUrl
 * @property {InsuranceType[]} popularForInsuranceTypes
 */

/**
 * @type {Object.<string, PopularInsuranceData>}
 */
export const PopularInsurances = {
    Aetna: {
        name: 'Aetna',
        mappableInsuranceIds: [212, 300],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_300_high.svg',
        popularForInsuranceTypes: [
            InsuranceType.Health,
            InsuranceType.Dental,
            InsuranceType.Vision,
        ],
    },
    BCBS: {
        name: 'BlueCross BlueShield',
        mappableInsuranceIds: [
            219, 230, 237, 251, 252, 253, 254, 255, 258, 278, 287, 304, 305,
            314, 324, 336, 348, 363, 438, 448, 451, 509, 543, 545, 550, 557,
            563, 564, 565, 566, 568, 572, 573, 574, 601, 602, 603, 635, 638,
            639, 640, 673, 676, 685, 698, 712, 715, 723, 724, 725, 726, 744,
            752, 756, 757, 758, 789, 790, 791, 792, 793, 794, 795, 797, 798,
            808, 809, 810, 813, 814, 827, 828, 829, 830, 853, 854, 855, 856,
            903, 996, 997, 998, 999, 1000, 1010, 1011, 1017, 1018, 1025, 1035,
            1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046,
            1047, 1048, 1049, 1050, 1051, 1073, 1076, 1077, 1080, 1081, 1094,
            1095, 1096, 1097, 1109, 1110, 1153, 1198, 1201, 1202, 1207, 1214,
            1216, 1225, 1232, 1238, 1259, 1260, 1335, 1355, 1400, 1412, 1413,
            1518,
        ],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_304_high.svg',
        popularForInsuranceTypes: [
            InsuranceType.Health,
            InsuranceType.Dental,
            InsuranceType.Vision,
        ],
    },
    Cigna: {
        name: 'Cigna',
        mappableInsuranceIds: [222, 307],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_307_high.svg',
        popularForInsuranceTypes: [
            InsuranceType.Health,
            InsuranceType.Dental,
            InsuranceType.Vision,
        ],
    },
    DavisVision: {
        name: 'Davis Vision',
        mappableInsuranceIds: [538],
        imageUrl: 'http://dum01j710waoj.cloudfront.net/insurance_538_high.svg',
        popularForInsuranceTypes: [InsuranceType.Vision],
    },
    DeltaDental: {
        name: 'Delta Dental',
        mappableInsuranceIds: [223],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_223_high.svg',
        popularForInsuranceTypes: [InsuranceType.Dental],
    },
    Emblem: {
        name: 'Emblem Health',
        mappableInsuranceIds: [234, 246, 337, 338, 349, 350],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_349_high.png',
        popularForInsuranceTypes: [InsuranceType.Health, InsuranceType.Vision],
    },
    EyeMed: {
        name: 'EyeMed',
        mappableInsuranceIds: [539],
        imageUrl: 'http://dum01j710waoj.cloudfront.net/insurance_539_high.svg',
        popularForInsuranceTypes: [InsuranceType.Vision],
    },
    Guardian: {
        name: 'Guardian',
        mappableInsuranceIds: [235],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_235_high.svg',
        popularForInsuranceTypes: [InsuranceType.Dental],
    },
    Medicare: {
        name: 'Medicare',
        mappableInsuranceIds: [356, 1479],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_356_high.svg',
        popularForInsuranceTypes: [InsuranceType.Health],
    },
    Metlife: {
        name: 'Metlife',
        mappableInsuranceIds: [239],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_239_high.svg',
        popularForInsuranceTypes: [InsuranceType.Dental],
    },
    UnitedHealthcare: {
        name: 'UnitedHealthcare',
        mappableInsuranceIds: [323, 243],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_323_high.svg',
        popularForInsuranceTypes: [
            InsuranceType.Health,
            InsuranceType.Dental,
            InsuranceType.Vision,
        ],
    },
    UnitedHealthcareOxford: {
        name: 'UnitedHealthcare Oxford',
        mappableInsuranceIds: [330, 286],
        imageUrl: 'https://dum01j710waoj.cloudfront.net/insurance_330_high.png',
        popularForInsuranceTypes: [InsuranceType.Health],
    },
    VSP: {
        name: 'VSP',
        mappableInsuranceIds: [441],
        imageUrl: 'http://dum01j710waoj.cloudfront.net/insurance_441_high.svg',
        popularForInsuranceTypes: [InsuranceType.Vision],
    },
};
